import { render, staticRenderFns } from "./UserManageList.vue?vue&type=template&id=5c0636be&"
import script from "./UserManageList.vue?vue&type=script&lang=js&"
export * from "./UserManageList.vue?vue&type=script&lang=js&"
import style0 from "./UserManageList.vue?vue&type=style&index=0&id=5c0636be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports